// The standalone backoffice does not load the Electron renderer translations.
const copy = {
  es: ['Conectar OAuth', 'OAuth disponible', 'OAuth necesita autorización'],
  en: ['Connect OAuth', 'OAuth available', 'OAuth needs authorization'],
  fr: ['Connecter OAuth', 'OAuth disponible', 'OAuth nécessite une autorisation'],
  de: ['OAuth verbinden', 'OAuth verfügbar', 'OAuth benötigt eine Autorisierung'],
  ru: ['Подключить OAuth', 'OAuth доступен', 'Требуется авторизация OAuth'],
  zh: ['连接 OAuth', 'OAuth 可用', 'OAuth 需要授权'],
  ja: ['OAuth を接続', 'OAuth 利用可能', 'OAuth の認可が必要です'],
  hi: ['OAuth कनेक्ट करें', 'OAuth उपलब्ध है', 'OAuth के लिए अनुमति आवश्यक है'],
  ar: ['ربط OAuth', 'OAuth متاح', 'يتطلب OAuth تفويضًا'],
  pt: ['Conectar OAuth', 'OAuth disponível', 'OAuth precisa de autorização'],
  ko: ['OAuth 연결', 'OAuth 사용 가능', 'OAuth 인증이 필요합니다'],
  it: ['Collega OAuth', 'OAuth disponibile', 'OAuth richiede autorizzazione'],
  id: ['Hubungkan OAuth', 'OAuth tersedia', 'OAuth memerlukan otorisasi']
};
export function trackingText(key) {
  const language = (document.documentElement.lang || navigator.language || 'es').split('-')[0];
  return (copy[language] || copy.es)[{ connect: 0, ready: 1, authorize: 2 }[key]];
}
